import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { LoginPage } from "./pages/Login";
import { CallbackPage } from "./pages/Callback";
import { InvitePage } from "./pages/Invite";
import { SelectContractPage } from "./pages/SelectContract";
import { ContractLayout } from "./pages/ContractLayout";
import { TopPage } from "./pages/Top";
import { MembersPage } from "./pages/Members";
import { ContractSettingsPage } from "./pages/ContractSettings";
import { SubscriptionsPage } from "./pages/Subscriptions";
import { ProfilePage } from "./pages/Profile";
import { SystemPage } from "./pages/System";
import { SystemAdminsPage } from "./pages/SystemAdmins";
import { CreateContractPage } from "./pages/CreateContract";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/select" replace />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/callback" element={<CallbackPage />} />
        <Route path="/invite" element={<InvitePage />} />
        <Route path="/select" element={<SelectContractPage />} />
        <Route path="/contracts/new" element={<CreateContractPage />} />
        <Route path="/system" element={<SystemPage />} />
        <Route path="/system/admins" element={<SystemAdminsPage />} />
        <Route path="/c/:contractId" element={<ContractLayout />}>
          <Route index element={<TopPage />} />
          <Route path="members" element={<MembersPage />} />
          <Route path="settings" element={<ContractSettingsPage />} />
          <Route path="subscriptions" element={<SubscriptionsPage />} />
          <Route path="profile" element={<ProfilePage />} />
        </Route>
        <Route path="*" element={<Navigate to="/select" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
